import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HTSBody = styled.div`
  flex-grow: 1;
`;

const HTSOption = styled.div`
  background-color: var(--color-bg-weaker);
  border-radius: var(--size-border-radius-md);
  margin-top: 40px;
  padding: 24px;
`;

const HTSOptionBody = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 24px;
  max-width: 688px;
`;

const HTSOptionShare = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  margin-top: 32px;
  padding: 40px;
  position: relative;
`;

const HTSOptionShareTitle = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-bg-stronger);
  border-radius: var(--size-border-radius-pill);
  left: 40px;
  padding: 7px 12px;
  position: absolute;
  top: 0;
  transform: translateY(-50%);
`;

const TabDescription = styled(Typography)`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  justify-content: space-between;
  min-width: 300px;
  width: 100%;
`;

export { HTSBody, HTSOption, HTSOptionBody, HTSOptionShare, HTSOptionShareTitle, TabDescription };
